<template>
    <li
        class="house-slider-item layout6"
        :class="{ mobile: isMobile }"
        :title="address"
        @click="openDetail(link, $event)"
    >
        <article>
            <div class="house-imgs">
                <a
                    :href="linkData.href"
                    :target="linkData.target"
                    :aria-label="linkData['aria-label']"
                    :rel="linkData.rel"
                    :self="linkData.self"
                >
                    <site-img
                        :src="firstImage"
                        :errorImg="defHouseImg"
                        :alt="address"
                        dir="width"
                    />
                    <house-mask
                        v-if="isShowMask"
                        display="fill-up"
                    />
                </a>
                <p v-if="soldDate" :class="['house-sold-date', statusOrigin]">
                    <only-client>
                        <span v-if="showStar">{{ $t('md-house.soldOnWith', { soldDate: $ft.formatDate(soldDate, 'MM/dd/yyyy') }) }}</span>
                        <span v-else>{{ $t('md-house.soldOn', { soldDate: $ft.formatDate(soldDate, 'MM/dd/yyyy') }) }}</span>
                    </only-client>
                </p>
            </div>
            <div class="house-info">
                <div class="house-price-wrap">
                    <title-mask-v2 v-if="isShowMask" />
                    <no-disclosure
                        v-else-if="!!house.nodisclosureDes || hidePrice"
                        :des="
                            hidePrice
                                ? $t('md-house.nondisclosure')
                                : house.nodisclosureDes
                        "
                    />
                    <a
                        v-else-if="soldDate"
                        class="house-price-link"
                        :href="linkData.href"
                        :target="linkData.target"
                        :aria-label="linkData['aria-label']"
                        :rel="linkData.rel"
                        :self="linkData.self"
                    >
                        <span class="house-sold-price">
                            {{ markPrice.replace(/\s/g, '') }}
                        </span>
                        <div class="sold-price-trend">
                            <span
                                class="house-initial-price"
                                v-if="showAllPrice && initialPrice"
                            >
                                {{ $ft.trim(initialPrice) }}
                            </span>
                            <HouseTrend
                                v-if="showAllPrice && trend"
                                :trendStatus="trendStatus"
                                :trend="trend"
                            />
                        </div>
                    </a>
                    <a
                        v-else
                        class="house-price-link"
                        :href="linkData.href"
                        :target="linkData.target"
                        :aria-label="linkData['aria-label']"
                        :rel="linkData.rel"
                        :self="linkData.self"
                    >
                        <div class="house-price">
                            {{ price.replace(/\s/g, '') }}
                        </div>
                    </a>
                </div>
                <p class="detail">
                    <span
                        :class="['vertical-line', `house-${item.key}`]"
                        v-for="item in basic"
                        :key="item.key"
                    >{{ item.text }}</span>
                </p>
                <h3 class="address" v-if="address">
                    <a
                        :href="linkData.href"
                        :target="linkData.target"
                        :aria-label="linkData['aria-label']"
                        :rel="linkData.rel"
                        :self="linkData.self"
                    >{{ address }}</a>
                </h3>
                <div class="mls-box">
                    <div
                        class="mls-provided"
                    >
                        <p v-if="showMls" class="house-mls-id">
                            MLS# {{ mlsid }}
                        </p>
                        <p
                            v-if="provided && !isShowMask"
                            class="desc ws-pre-wrap"
                        >
                            {{ provided }}
                        </p>
                    </div>
                    <site-img
                        v-if="mlsLogo"
                        class="house-mls-logo"
                        :src="mlsLogo"
                        :alt="mlsAlt"
                        :size="30"
                        dir="height"
                    />
                </div>
            </div>
        </article>
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </li>
</template>
<script>
import HouseItem from '../house-item.js';
import OnlyClient from '@/components/global/only-client.vue';
export default {
    components: { OnlyClient },
    mixins: [HouseItem],
    data() {
        return {
            // isShowMask: true
        }
    }
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';
.house-slider-item.layout6 {
    list-style: none;
    width: 100%;
    height: 100%;
    border: 1px solid rgba(218, 218, 218, 0.5);
    padding: 15px;

    > article {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .house-imgs {
        width: 100%;
        height: 224px;
        position: relative;
        flex-shrink: 0;
        overflow: hidden;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.3s ease;
            &:hover {
                transform: scale(1.1);
            }
        }
        .house-sold-date {
            position: absolute;
            left: 20px;
            top: 20px;
            z-index: 2;
            span {
                display: inline-block;
                font-family: var(--font-normal);
                font-size: 12px;
                font-weight: 700;
                height: 20px;
                line-height: 20px;
                padding: 0 5px;
                border-radius: 0;
                color: #fff;
                background-color: #505050;
            }
        }
    }
    .house-info {
        padding-top: 15px;
        display: flex;
        flex-direction: column;

        .house-price-wrap {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            .nodisclosure {
                .dollar,
                .secret {
                    color: var(--color-success);
                }
            }
            .house-price-link {
                display: block;
                color: inherit;
                text-decoration: none;
                &:hover {
                    text-decoration: none;
                }
            }
            .house-sold-price,
            .house-price {
                color: var(--g-primary-color);
                font-weight: 700;
                font-size: 24px;
                font-family: var(--font-bold);
                height: 36px;
                line-height: 36px;
            }
            .sold-price-trend {
                display: flex;
                height: 20px;
            }
            .house-initial-price {
                color: var(--g-tip-color);
                font-size: 16px;
                line-height: 20px;
                font-weight: 400;
                margin-left: 10px;
                text-decoration: line-through;
            }
        }
        .detail,
        .address {
            margin-top: 5px;
            color: var(--g-text-color);
            font-family: var(--font-title);
            font-size: 12px;
            font-weight: 400;
            line-height: 18px;
            text-align: left;
            @include webkitBox(2);
        }
        .detail {
            .vertical-line:after {
                content: '|';
                display: inline;
                margin: 0 8px;
                color: var(--g-text-color);
            }
            .vertical-line:nth-last-child(1):after {
                content: '';
            }
        }
        .mls-box {
            margin-top: 15px;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            .mls-provided {
                flex: 1;
            }
            .house-mls-id,
            .desc {
                font-weight: 400;
                font-size: 12px;
                line-height: 18px;
                color: var(--g-tip-color);
                @include webkitBox(2);
            }
            @media (max-width: 1200px) {
                .desc {
                    @include webkitBox(1);
                }
            }

            .house-mls-logo {
                object-fit: cover;
                margin-left: 10px;
                max-height: 20px;
                max-width: 60px;
                @include media-min-800 {
                    max-width: 80px;
                }
                @include media-min-1080 {
                    max-width: 100px;
                }
                @include media-min-1440 {
                    max-width: 120px;
                }
            }
        }
    }

    &:hover {
        box-shadow: 0px 4px 20px 0px #1919191A;
    }

    &.mobile {
        height: auto;
        margin-bottom: 15px;
        .house-info {
            .house-mls-logo {
                max-height: 20px;
                max-width: 120px;
            }
        }
    }
}
.item-box:last-child {
    .house-slider-item.layout6 {
        &.mobile {
            margin-bottom: 20px;
        }
    }
}
</style>
